(function ($) {

    // Toggle filter popup
    $(document).on('click', '.filter-toggle', function () {
        $('.filter-container').toggleClass('is-open');
    });

})(jQuery);